import {
  Autocomplete,
  Avatar,
  Box, Card,
  CardHeader,
  Dialog,
  DialogContent,
  DialogContentText,
  ListItemSecondaryAction,
  MenuItem,
  Paper,
  Stack,
  TextField
} from "@mui/material";
import React, {useState} from "react";
import IconButton from "@mui/material/IconButton";
import {AddCircle, Close, DeleteForever, GroupAdd, Person, PersonAdd, PersonAddAlt1} from "@mui/icons-material";
import useAxios from "axios-hooks";
import TourService from "../../services/tour.service";
import ListItemText from "@mui/material/ListItemText";
import {sticketTheme} from "../../theme/sticketTheme";
import CustomConfirmDialog from "../../components/CustomConfirmDialog";
import {filter, find} from "lodash";
import axios from "axios";
import AddTourManagerDialog from "./AddTourManagerDialog";

const HandleTourManagers = ({tour_id}) => {
  const [{data: tourManagers, loading: loadingTourManagers, error: errorTourManagers}, fetchTourManagers] = useAxios(
    TourService.allTourManagersUrl(), {method: "GET", useCache: false, manual: true}
  )

  const [open, setOpen] = useState(false);

  const handleToggleDialog = () => {
    if (!open) {
      fetchTourManagers();
    }
    setOpen(!open)
  }

  const handleTourManager = (manager_id, link) => {
    axios.put(`${TourService.allTourManagersUrl(manager_id)}/${link}`, {tour_id: tour_id})
      .then(res => {
        fetchTourManagers()
      })
      .catch(err => console.log("handleTourManager > err:", err))
      .finally()
  }

  return (
    <Stack>
      <IconButton color={'secondary'} onClick={handleToggleDialog}>
        <GroupAdd/>
      </IconButton>
      <Dialog open={open} onClose={handleToggleDialog} fullWidth maxWidth={'sm'}>
        <DialogContent>
          <DialogContentText variant={'h5'} fontWeight={'bold'}>
            <Box display={'flex'}>
              Tour Sticket Crew
              <IconButton onClick={handleToggleDialog}
                          children={<Close/>}
                          sx={{ml: 'auto'}}
              />
            </Box>
          </DialogContentText>

          <Stack direction={'row'} spacing={1}>
            <Paper variant={'outlined'} sx={{width: '100%', p: 1}}>
              {<Autocomplete
                fullWidth
                options={tourManagers || []}
                loading={loadingTourManagers}
                multiple
                disableCloseOnSelect
                getOptionLabel={(option) => option.name || option.id}
                renderInput={(params) => <TextField fullWidth {...params} label="Add Tour Managers"/>}
                renderOption={(props, option, {selected}) => (
                  <MenuItem value={option} disabled={find(filter(tourManagers, function (o) {
                    return o?.tour_ids?.includes(tour_id)
                  }), ['id', option.id])}
                            onClick={() => handleTourManager(option.id, 'link')}
                  >
                    <ListItemText
                      primary={(option.name)?.toUpperCase()}
                      secondary={<a style={{color: sticketTheme.palette.secondary.main}}
                                    href={`mailto:${option.email}`}>{option.email}</a>}/>
                    <ListItemSecondaryAction>
                      <AddCircle/>
                    </ListItemSecondaryAction>
                  </MenuItem>
                )}
              />}
            </Paper>
            <AddTourManagerDialog refetch={fetchTourManagers}/>
          </Stack>
          <Stack mt={2} spacing={1}>
            {
              (filter(tourManagers, function (o) {
                return o?.tour_ids?.includes(tour_id)
              })).map((tourManager) => {
                return (<Card>
                  <CardHeader
                    avatar={
                      <Avatar sx={{
                        bgcolor:
                        sticketTheme.palette.secondary.main
                      }}
                              aria-label="recipe">
                        <Person/>
                      </Avatar>
                    }
                    action={<CustomConfirmDialog
                      color={sticketTheme.palette.error.main}
                      icon={<DeleteForever/>}
                      confirmAction={() => handleTourManager(tourManager.id, 'unlink')}
                    />}
                    title={(tourManager.name).toUpperCase()}
                    subheader={<a style={{color: sticketTheme.palette.secondary.main}}
                                  href={`mailto:${tourManager.email}`}>{tourManager.email}</a>}/>
                </Card>)
              })
            }

          </Stack>
        </DialogContent>
      </Dialog>
    </Stack>
  )
}

export default HandleTourManagers